import './styles/FaqStyle.css';
import { createElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { questionContentPropTypes } from '../constants';
import Body from './ArticleBody';
import ArticleButtonLink from './ArticleButtonLink';
import Image from './ArticleImage';
import Subtitle from './ArticleSubtitle';
import Title from './ArticleTitle';
import FaqText from './FaqText';
import messages from './messages';

const Components = {
  title: Title,
  subtitle: Subtitle,
  body: Body,
  img: Image,
  buttonLink: ArticleButtonLink,
};

const ArticleComponent = ({ content }) => {
  if (Components[content.type]) {
    return createElement(Components[content.type], {
      content: content.content,
      imgSizePercent: content.imgSizePercent,
      imgAlt: content.imgAlt,
      href: content.href,
    });
  }
  // If the type of the component is unknown
  return (
    <FaqText id="errorMessage">
      [{content.type}] - <FormattedMessage {...messages.typeNotFound} />
    </FaqText>
  );
};

ArticleComponent.propTypes = {
  content: questionContentPropTypes,
};

export default ArticleComponent;
